import * as DialogPrimitive from "@radix-ui/react-dialog";
import type { ComponentProps } from "react";
import { usePortalContainer } from "../../context/PortalContainerContext";

/**
 * Thin wrapper around Radix DialogPrimitive.Portal.
 *
 * Consumes PortalContainerContext to redirect portaled content into a scoped
 * DOM element when one is provided (e.g. by OrganizationThemeProvider in portal-web).
 * This ensures dialog overlays inherit CSS custom properties scoped to the portal
 * wrapper rather than rendering into document.body and losing those vars.
 *
 * A caller-supplied `container` prop always takes precedence over the context value.
 */
export const DialogPortal = ({ container, ...props }: ComponentProps<typeof DialogPrimitive.Portal>) => {
  const contextContainer = usePortalContainer();
  return (
    <DialogPrimitive.Portal
      data-slot="dialog-portal"
      container={container ?? contextContainer ?? undefined}
      {...props}
    />
  );
};
